import React from 'react';
import { Divider, Skeleton, Row } from 'antd';

const PixSkeleton = () => {
  return (
    <>
      <Row justify="space-between" align="middle">
        <div>
          <Skeleton.Button active style={{ width: 150 }} />
          <br /> <br />
          <Skeleton.Button active style={{ width: 300 }} />
        </div>

        <div>
          <Skeleton.Button active style={{ width: 50 }} />
        </div>
        <Divider />
      </Row>
      <Row justify="space-between" align="middle">
        <div>
          <Skeleton.Button active style={{ width: 150 }} />
          <br /> <br />
          <Skeleton.Button active style={{ width: 300 }} />
        </div>

        <div>
          <Skeleton.Button active style={{ width: 50 }} />
        </div>
        <Divider />
      </Row>
      <Row justify="space-between" align="middle">
        <div>
          <Skeleton.Button active style={{ width: 150 }} />
          <br /> <br />
          <Skeleton.Button active style={{ width: 300 }} />
        </div>

        <div>
          <Skeleton.Button active style={{ width: 50 }} />
        </div>
        <Divider />
      </Row>
    </>
  );
};

export default PixSkeleton;
